import { render, staticRenderFns } from "./InternationalWallet.vue?vue&type=template&id=ff264600&scoped=true"
import script from "./InternationalWallet.vue?vue&type=script&lang=js"
export * from "./InternationalWallet.vue?vue&type=script&lang=js"
import style0 from "./InternationalWallet.vue?vue&type=style&index=0&id=ff264600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff264600",
  null
  
)

export default component.exports